// extracted by mini-css-extract-plugin
export default {"cards":"Stats_cards__0dTOk","referralCode":"Stats_referralCode__Gd0iz","label":"Stats_label__Ei0BG","copyButton":"Stats_copyButton__OPwcH"};